import { render, staticRenderFns } from "./DataPack.vue?vue&type=template&id=1da5f970&"
import script from "./DataPack.vue?vue&type=script&lang=js&"
export * from "./DataPack.vue?vue&type=script&lang=js&"
import style0 from "./DataPack.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DataPack.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports